import { render, staticRenderFns } from "./MovePresentationV2.vue?vue&type=template&id=c933e13e"
import script from "./MovePresentationV2.vue?vue&type=script&lang=js"
export * from "./MovePresentationV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports